import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { DataRetentionPolicyDetailCategory } from "../../../../common/service/server/dto/DataRetentionPolicyDto";
import { DATA_RETENTION_CATEGORIES, formattedCategoryLabel } from "./DataRetentionCategoryQuestion";

type DataRetentionCategoryQuestionProps = {
  category: DataRetentionPolicyDetailCategory;
  onRestore: () => void;
};

export const DataRetentionCategoryQuestionDisabled: React.FC<
  DataRetentionCategoryQuestionProps
> = ({ category, onRestore }) => {
  const label = DATA_RETENTION_CATEGORIES[category].label;
  const formattedLabel = formattedCategoryLabel(category, label);

  return (
    <div className="mb-lg border-color-neutral-300 box-rounded no-overflow">
      <div className="bg-gray p-md d-flex flex-row flex--between flex--align-center">
        <h6 className="my-0 text-weight-medium">{formattedLabel}</h6>
        <FormControlLabel
          control={
            <Checkbox
              checked={true}
              onChange={({ target }) => {
                if (!target.checked) {
                  onRestore();
                }
              }}
            />
          }
          label="Not Applicable"
        />
      </div>

      <div className="p-md">
        This data retention purpose was marked as not applicable and will not appear on your Privacy
        Policy.
      </div>
    </div>
  );
};
